import { useAssignClipboard } from './useAssignClipboard'
import { useStack } from 'vue-stacked-ui'

let globalHandler: ((event: KeyboardEvent) => void) | null = null

export function useGlobalKeyListener() {
  const clipboard = useAssignClipboard()
  const stackUI = useStack()

  const handleGlobalKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      clipboard.resetState()

      if (stackUI.getStacks().length > 1) {
        stackUI.pop()
      }
    }
  }

  const register = (doc: Document) => {
    if (doc === undefined) return
    globalHandler = handleGlobalKeydown
    doc.addEventListener('keydown', globalHandler)
  }

  const unregister = (doc: Document) => {
    if (doc === undefined) return
    if (globalHandler) {
      doc.removeEventListener('keydown', globalHandler)
    }
    globalHandler = null
  }

  return {
    register,
    unregister
  }
}
